// extracted by mini-css-extract-plugin
export var actionButton = "_gi-0";
export var attachmentLine = "_gi-1";
export var fileInput = "_gi-2";
export var fileUploadWrapper = "_gi-4";
export var footer = "_gi-3";
export var modalContent = "_gi-5";
export var paperclip = "_gi-6";
export var quillEditor = "_gi-7";